import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import AppFooter from '../layout/AppFooter'
import AppHeader from '../layout/AppHeader'
import Shell from '../layout/Shell'

export default function LandingCard({ onStart, loading, error }) {
  const { t } = useTranslation()
  const sections = [
    ['01', t('landing.sections.scope.title'), t('landing.sections.scope.description')],
    ['02', t('landing.sections.classification.title'), t('landing.sections.classification.description')],
    ['03', t('landing.sections.readiness.title'), t('landing.sections.readiness.description')],
  ]

  return (
    <Shell>
      <AppHeader />
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 }, flexGrow: 1 }}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Stack spacing={3}>
              <Typography variant="h2">{t('landing.title')}</Typography>
              <Typography color="text.secondary" fontSize={16}>
                {t('landing.description')}
              </Typography>
              {error ? <Alert severity="error">{error}</Alert> : null}
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                <Button
                  size="large"
                  color="primary"
                  variant="contained"
                  endIcon={loading ? <CircularProgress color="inherit" size={16} /> : <ArrowForwardIcon />}
                  onClick={onStart}
                  disabled={loading}
                >
                  {t('landing.start')}
                </Button>
              </Stack>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Paper variant="outlined" sx={{ p: 3, bgcolor: 'background.paper' }}>
              <Stack spacing={2.5}>
                {sections.map(([number, title, description]) => (
                  <Stack key={number} direction="row" spacing={2} alignItems="flex-start">
                    <Typography color="text.secondary" fontWeight={700} sx={{ width: 32, flexShrink: 0 }}>
                      {number}
                    </Typography>
                    <Box>
                      <Typography variant="h5">{title}</Typography>
                      <Typography color="text.secondary">{description}</Typography>
                    </Box>
                  </Stack>
                ))}
                <Divider />
                <Typography id="what-you-get" variant="body2" color="text.secondary">
                  {t('landing.reportIncludes')}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <AppFooter />
    </Shell>
  )
}
